import React, { useState, useContext } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import { ThemeContext } from 'styled-components';
import {
  TableEmpty,
  CadastroEstacaoModal,
  Icon,
  ModalClose,
  ModalConfirmation,
  Skeleton,
} from '..';
import { notifyError } from '../../utils';
import { icons } from '../../assets';
import { postEditEstacoes } from '../../services';
import * as s from './styled-stations-table';

const TableEstacoes = ({
  loading,
  data,
  buscaEstacoes,
  listCustomer,
  listZona,
}) => {
  const [closeConfirmation, setCloseConfirmation] = useState(false);
  const { title, colors } = useContext(ThemeContext);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [isModalEditVisibleConcluido, setIsModalEditVisibleConcluido] =
    useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [estacaoEditado, setEstacaoEditado] = useState();
  const [estacaoSelecionado, setEstacaoSelecionado] = useState({
    name: '',
    cep: '',
    endereco: '',
    complemento: '',
    latitude: '',
    longitude: '',
    cidade: '',
    zona: '',
    customer: '',
  });

  createTheme('darkmode', {
    background: {
      default: colors.card,
    },
    divider: {
      default: colors.disabled,
    },
    highlightOnHover: {
      default: colors.lightgrey,
    },
  });

  const columns = [
    {
      name: 'Estação',
      selector: '',
      sortable: false,
      minWidth: '185px',
      cell: ({ name }) => <s.Label color={colors.label}>{name}</s.Label>,
    },
    {
      name: 'Cliente',
      selector: '',
      sortable: false,
      minWidth: '185px',
      cell: ({ customer }) => (
        <s.Label color={colors.label}>{customer ? customer.name : ''}</s.Label>
      ),
    },
    {
      name: 'Estado',
      selector: '',
      sortable: false,
      minWidth: '186px',
      cell: ({ zone }) => (
        <s.Label color={colors.label}>{zone ? zone.name : ''}</s.Label>
      ),
    },
    {
      name: 'Editar',
      selector: '',
      sortable: false,
      maxWidth: '10%',
      cell: (row) => (
        <s.IconButton
          type="button"
          onClick={() => {
            setIsModalEditVisible(true);
            setEstacaoSelecionado({
              id: row.id ? row.id : '',
              name: row.name ? row.name : '',
              cep: row.postalcode ? row.postalcode : '',
              estado: row.state ? row.state : '',
              cidade: row.city ? row.city : '',
              endereco: row.address ? row.address : '',
              bairro: row.district ? row.district : '',
              numero: row.addressnumber ? row.addressnumber : '',
              latitude: row.lat ? row.lat : '',
              longitude: row.lng ? row.lng : '',
              zona: row.zone ? row.zone : '',
              customer: row.customer ? row.customer : '',
            });
          }}
          title="Editar estação"
        >
          <Icon name="pencil" size={18} />
        </s.IconButton>
      ),
      style: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
  ];

  const editarEstacao = (values) => {
    postEditEstacoes(estacaoSelecionado.id, {
      name: values.name,
      postalcode: values.cep,
      state: values.estado,
      city: values.cidade,
      district: values.bairro,
      address: values.endereco,
      addressnumber: values.numero,
      lat: values.latitude,
      lng: values.longitude,
      customer: values.customer,
      zone: values.zona,
    })
      .then(() => {
        setIsModalEditVisible(false);
        setConfirmationModal(false);
        setIsModalEditVisibleConcluido(true);
        buscaEstacoes();
      })
      .catch((error) => {
        if (error && error.message) notifyError(error.message);
        else notifyError('Ocorreu um erro ao salvar a estação');

        setConfirmationModal(false);
      });
  };

  return (
    <>
      {confirmationModal && (
        <ModalConfirmation
          onClose={() => {
            editarEstacao(estacaoEditado);
          }}
          onCloseConfirmation={setConfirmationModal}
        />
      )}
      {isModalEditVisibleConcluido && (
        <CadastroEstacaoModal
          onClose={() => {
            setIsModalEditVisibleConcluido(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
          setEstacaoConcluido={setIsModalEditVisibleConcluido}
          estacaoConcluido={isModalEditVisibleConcluido}
          formikInitialValues={estacaoSelecionado}
          listCustomer={listCustomer}
          listZona={listZona}
          title="Editar Estação"
          sucesso="Estação editada com sucesso!"
          iconFinal={icons.EstacoesIconEdit}
        />
      )}
      {isModalEditVisible && (
        <CadastroEstacaoModal
          onClose={() => {
            setIsModalEditVisible(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
          submit={setEstacaoEditado}
          setConfirmationModal={setConfirmationModal}
          setEstacaoConcluido={setIsModalEditVisibleConcluido}
          estacaoConcluido={isModalEditVisibleConcluido}
          formikInitialValues={estacaoSelecionado}
          listCustomer={listCustomer}
          listZona={listZona}
          title="Editar Estação"
          dadosAbaixo="Modifique os dados abaixo:"
          msgButton="Confirme suas modificações"
          labelButton="SALVAR"
          sucesso="Estação editada com sucesso!"
          estadoValue={estacaoSelecionado.estado}
          iconFinal={icons.EstacoesIconEdit}
        />
      )}
      {closeConfirmation && (
        <ModalClose
          onClose={() => {
            setIsModalEditVisible(false);
            setCloseConfirmation(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
        />
      )}
      <DataTable
        theme={title === 'light' ? 'default' : 'darkmode'}
        noHeader
        columns={columns}
        data={data}
        highlightOnHover
        fixedHeader
        responsive
        pagination={false}
        persistTableHead
        progressPending={loading}
        noDataComponent={
          <TableEmpty
            titulo="Nenhuma estação foi encontrada"
            subtitulo="Cadastre estações para começar"
            icon={icons.FactoryIconGray}
          />
        }
        ignoreRowClick
        customStyles={{
          table: {
            style: {
              flex: 1,
              marginTop: '10px',
              marginBottom: '5px',
              height: '100%',
              paddingBottom: '1.0vh',
            },
          },
          headRow: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          rows: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          cells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
          headCells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        }}
        progressComponent={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              padding: 16,
              gap: 8,
            }}
          >
            <Skeleton count={6} height="32px" />
          </div>
        }
      />
    </>
  );
};

export default TableEstacoes;
